import { render, staticRenderFns } from "./ProductDetailsCondensed.vue?vue&type=template&id=aefd8d44"
import script from "./ProductDetailsCondensed.vue?vue&type=script&lang=js"
export * from "./ProductDetailsCondensed.vue?vue&type=script&lang=js"
import style0 from "./scss/product-details-simplified.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/booking-staging.greenmotion.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aefd8d44')) {
      api.createRecord('aefd8d44', component.options)
    } else {
      api.reload('aefd8d44', component.options)
    }
    module.hot.accept("./ProductDetailsCondensed.vue?vue&type=template&id=aefd8d44", function () {
      api.rerender('aefd8d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/greenmotion-shared/Components/quotes/ProductDetailsCondensed.vue"
export default component.exports